export default __webpack_public_path__ + "static/media/ecuador_flag.88585927.svg";